import { contactData } from '@/mocks/tanhua';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="max-w-2xl mx-auto">
          <div className="text-center mb-8 md:mb-10">
            <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">
              {contactData.title}
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              {contactData.desc}
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div className="flex items-center gap-3 p-4 bg-background-100 rounded-lg border border-background-200/70">
              <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-mail-line text-lg text-primary-500"></i>
              </div>
              <div className="min-w-0">
                <div className="text-xs text-foreground-500 mb-0.5">邮箱</div>
                <div className="text-sm text-foreground-800 truncate">{contactData.email}</div>
              </div>
            </div>

            <div className="flex items-center gap-3 p-4 bg-background-100 rounded-lg border border-background-200/70">
              <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-wechat-line text-lg text-accent-500"></i>
              </div>
              <div className="min-w-0">
                <div className="text-xs text-foreground-500 mb-0.5">微信</div>
                <div className="text-sm text-foreground-800 truncate">{contactData.wechat}</div>
              </div>
            </div>

            <div className="flex items-center gap-3 p-4 bg-background-100 rounded-lg border border-background-200/70">
              <div className="w-10 h-10 rounded-lg bg-secondary-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-qq-line text-lg text-secondary-500"></i>
              </div>
              <div className="min-w-0">
                <div className="text-xs text-foreground-500 mb-0.5">QQ</div>
                <div className="text-sm text-foreground-800 truncate">{contactData.qq}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}